<template>
  <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
    <template v-if="editableMode">
      <td class="text-center align-middle border-t border-r px-2">
        #
      </td>
      <td class="border-t">
        <div class="flex items-center px-6 focus:text-indigo-500">
          {{ orderDetail.item.name }}
        </div>
      </td>
      <td class="border-t">
        <div class="flex items-center px-6 py-4">
          {{ selectedItemUnit }}
        </div>
      </td>
      <td class="border-t text-right">
        <number-input
          v-model="detail.qty"
          class="px-4 py-4"
          :error="errors.qty" />
      </td>
      <td class="border-t text-right">
        <div class="px-6 py-4 text-right">
          {{ formatNumber(orderDetail.qty_recv) }}
        </div>
      </td>
      <td class="border-t text-right">
        <number-input
          v-model="detail.price"
          class="px-4 py-4"
          :error="errors.price" />
      </td>
      <td class="border-t text-right">
        <div class="px-6 py-4 text-right">
          {{ formatNumber(subtotal) }}
        </div>
      </td>
      <td class="w-px border-t">
        <div class="flex justify-items-end px-6 py-4">
          <button title="Save Changes" @click="store">
            <Icon icon="ic:baseline-save" class="block w-6 h-6 fill-gray-400" />
          </button>
          <button title="Cancel Edit" @click="cancel">
            <Icon icon="ic:baseline-restart-alt" class="block w-6 h-6 fill-gray-400" />
          </button>
        </div>
      </td>
    </template>
    <template v-else>
      <td class="text-center align-middle border-t border-r px-2">
        {{ rowNumber }}.
      </td>
      <td class="border-t">
        <div class="flex items-center px-6 focus:text-indigo-500">
          {{ orderDetail.item.name }}
        </div>
      </td>
      <td class="border-t text-left">
        <div class="flex items-center px-6 py-4">
          {{ selectedItemUnit }}
        </div>
      </td>
      <td class="border-t text-right">
        <div class="px-6 py-4 text-right">
          {{ formatNumber(orderDetail.qty) }}
        </div>
      </td>
      <td class="border-t text-right">
        <div class="px-6 py-4 text-right">
          {{ formatNumber(orderDetail.qty_recv) }}
        </div>
      </td>
      <td class="border-t text-right">
        <div class="px-6 py-4 text-right">
          {{ formatNumber(orderDetail.price) }}
        </div>
      </td>
      <td class="border-t text-right">
        <div class="px-6 py-4 text-right">
          {{ formatNumber(subtotal) }}
        </div>
      </td>
      <td class="w-px border-t">
        <div v-if="!disabled" class="flex items-center px-6 py-4">
          <button title="Edit Detail" @click="edit">
            <Icon icon="ic:baseline-edit-note" class="block w-6 h-6 fill-gray-400" />
          </button>
          <button title="Delete Detail" @click="destroy">
            <Icon icon="ic:baseline-delete" class="block w-6 h-6 fill-gray-400" />
          </button>
        </div>
      </td>
    </template>
  </tr>
</template>

<script lang="js">
import { Icon } from '@iconify/vue'
import { ref } from 'vue'
import NumberInput from '@/Shared/NumberInput'
import clone from 'lodash/clone'
import { find } from 'lodash'

export default {
    components: {
        Icon,
        NumberInput,
    },
    props: {
        orderDetail: Object,
        items: Object,
        errors: Object,
        editableMode: {
            type: Boolean,
            default: false,
        },
        rowIndex: {
            type: Number,
            default: 1,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        currentPage: {
            type: Number,
            default: 1,
        },
        perPage: {
            type: Number,
            default: 10,
        },
    },
    emits: ['destroy:detail', 'cancel', 'save', 'edit:detail'],
    setup (props) {
        const detail = ref(props.orderDetail)
        const oriData = ref(typeof orderDetail)

        return {
            detail,
            oriData,
        }
    },
    computed: {
        selectedItemUnit () {
            return this.detail.item_id ? find(this.items, ['id', this.detail.item_id]).unit : 'N/A'
        },
        subtotal () {
            return this.detail.qty * this.detail.price
        },
        rowNumber () {
            return (this.currentPage > 1) ? ((this.currentPage - 1) * this.perPage) + this.rowIndex : this.rowIndex
        },
    },
    methods: {
        formatNumber (num) {
            return num ? num.toLocaleString('id-ID', { minimumFractionDigits: 2 }) : '0'
        },
        setSelectedItem (item) {
            this.detail.item = item
        },
        edit () {
            this.oriData = clone(this.orderDetail)
            this.detail.item_unit_id = find(this.items, ['id', this.detail.item_id]).unit_id
            this.$emit('edit:detail', this.detail)
        },
        cancel () {
            this.detail = clone(this.oriData)
            this.$emit('cancel')
        },
        store () {
            this.detail.item_unit_id = find(this.items, ['id', this.detail.item_id]).unit_id
            this.$emit('save', this.detail)
        },
        destroy () {
            if (confirm('Are you sure you want to delete this details?')) {
                this.$emit('destroy:detail', this.orderDetail.id)
            }
        },
    },
}
</script>
